import FileIcon from '@mui/icons-material/Description'
import { Button, Typography } from '@mui/material'
import { get } from 'lodash'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import Loader from '../../../common/loader/Loader'
import { getHttpUrl } from '../../../common/utils'
import { User } from '../../auth/types'
import withUser from '../../auth/withUser'
import { i18n } from '../../index'
import type { Station } from '../../station/stationTypes'
import css from './links.css'
import LinksModal from './LinksModal'
import { deleteWeeklyInfoLink, fetchWeeklyInfoLinks } from './linksQueries'

type LinkTypes =
  | 'weekinfo_manager'
  | 'weekinfo_hall'
  | 'weekinfo_kitchen'
  | 'weekinfo_market'
  | 'weekinfo_hesburger'
  | 'monthlyinfo_manager'
  | 'monthlyinfo_hall'
  | 'monthlyinfo_kitchen'
  | 'monthlyinfo_market'
  | 'monthlyinfo_hesburger'

type LinksProps = {
  stationId: string
  linkType: LinkTypes
  companyId?: string
}

type LinksState = {
  modalIsOpen: boolean
}

type Link = {
  station: Station | null
  fileName: string
  href: string
  id: string
}

type InjectedProps = {
  user: User
}

@withUser
class Links extends React.Component<LinksProps, LinksState> {
  state = {
    modalIsOpen: false,
  }

  deleteLink = (e: Event, onMutate: (...args: Array<any>) => any, id: string) => {
    e.preventDefault()
    onMutate({
      variables: {
        id,
      },
    })
  }

  render() {
    const { stationId, user, linkType, companyId } = this.props as LinksProps & InjectedProps
    const { modalIsOpen } = this.state
    return (
      <div className={css.component}>
        <LinksModal
          isOpen={modalIsOpen}
          onClose={() =>
            this.setState({
              modalIsOpen: false,
            })
          }
          stationId={stationId}
          linksType={linkType}
          companyId={companyId}
        />

        <Query
          query={fetchWeeklyInfoLinks}
          variables={{
            stationId,
            type: linkType,
          }}
        >
          {({ loading, error, data }) => {
            const links: Link[] = get(data, 'weeklyInfoLinks', [])
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <Typography variant='h6' gutterBottom>
                  {i18n.t('weeklyInfo.title.links')}
                </Typography>
                {links && links.length > 0 && (
                  <div className={css.linksContainer}>
                    {links.map((link, i) => {
                      const canDelete = link.station !== null || user.userType === 'SokAdmin'
                      return (
                        <div key={i} className={css.link}>
                          <a href={getHttpUrl(link.href)} target={'_blank'} rel='noreferrer'>
                            <div className={css.linkContent}>
                              <FileIcon />

                              {link.fileName}

                              {canDelete && (
                                <Mutation
                                  mutation={deleteWeeklyInfoLink}
                                  refetchQueries={[
                                    {
                                      query: fetchWeeklyInfoLinks,
                                      variables: {
                                        stationId,
                                        type: linkType,
                                      },
                                    },
                                  ]}
                                >
                                  {(onMutate) => (
                                    <DeleteButton
                                      className={css.deleteButton}
                                      onClick={(e) => this.deleteLink(e, onMutate, link.id)}
                                    />
                                  )}
                                </Mutation>
                              )}
                            </div>
                          </a>
                        </div>
                      )
                    })}
                  </div>
                )}
              </Loader>
            )
          }}
        </Query>

        <div className={css.linksInputContainer}>
          <Button
            onClick={() =>
              this.setState({
                modalIsOpen: true,
              })
            }
            color={'primary'}
            variant='contained'
          >
            {i18n.t('weeklyInfo.button.addLinks')}
          </Button>
        </div>
      </div>
    )
  }
}

export default Links
